import React, { Component } from "react";
import {
  Box,
  Card,
  Container,
  Divider,
  Grid,
  TextField,
  MenuItem,
  Button,
  Skeleton,
  Avatar,
  Link,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import Autocomplete from "react-google-autocomplete";
import Menu from "@mui/material/Menu";
import Paper from "@mui/material/Paper";
import poo from "./assets/bgimg.jpg";
import MicIcon from "@mui/icons-material/Mic";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import rr from "./img/penter.png";
import ccc from "./img/new_home.jpg";
import d from "./img/d.webp";
import l from "./img/l.webp";
import HomeIcon from "@mui/icons-material/Home";
import property from "./img/property.webp";
import SearchIcon from "@mui/icons-material/Search";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

import CheckIcon from "@mui/icons-material/Check";
import socity_img from './socity_img/socity.jpg'
import CallIcon from '@mui/icons-material/Call';
import st from './plot_img/st.jpg'
import CloseIcon from '@mui/icons-material/Close';
import SingleBedIcon from '@mui/icons-material/SingleBed';
import AddHomeIcon from '@mui/icons-material/AddHome';
import VerifiedIcon from '@mui/icons-material/Verified';
import LandslideIcon from '@mui/icons-material/Landslide';
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { grey } from '@mui/material/colors';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import pg from './img/pg.webp'
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import PersonIcon from '@mui/icons-material/Person';
import EmojiSymbolsIcon from '@mui/icons-material/EmojiSymbols';
import BrushIcon from '@mui/icons-material/Brush';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import BusAlertIcon from '@mui/icons-material/BusAlert';
import HandymanIcon from '@mui/icons-material/Handyman';
import StoreIcon from '@mui/icons-material/Store';
import StyleIcon from '@mui/icons-material/Style';
import 'bootstrap/dist/css/bootstrap.min.css';


///// vendor
import car from './vendor_assets/car.png'
import manufacturer from './vendor_assets/manufacturer.png'
import penter from './vendor_assets/penter.png'
import pent from './vendor_assets/pent.jpg'
import repair from './vendor_assets/repair.jpg'
import travel_other from './other_vendor_img/travel_other.jpg'
import hotel from './other_vendor_img/hotel.jpg'
import cop from './other_vendor_img/cop.jpg'
import repaire from './other_vendor_img/repaire.webp'
import bann from './other_vendor_img/bann.webp'
import base from '../src/base.json'
import consultant_agency  from '../src/vendor_assets/consultant_agency.png'
import VoiceToText from "./VoiceToText";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import animation from '../src/animation.gif'
import Carousel from 'react-bootstrap/Carousel';









///AIzaSyDg2LA8IAl3SPgxqiAt1FBNb54Z8jk4kZ0
const api_key = "AIzaSyDg2LA8IAl3SPgxqiAt1FBNb54Z8jk4kZ0";
export class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "buy",
      anchorEl: null,
      open: false,
      display: false,

      //////////////// state data for location search field
      location_name: "",

      ////////////////// desktop viewable data 
       categoryList : [],
       vendorListByLocality:[],
       recomendedVendorList : [],

     is_ads_open:true,



    };
    this.setAnchorEl = this.setAnchorEl.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.child = React.createRef();
  }

  handleClick(event) {
    this.setAnchorEl(event.currentTarget);
  }

  setAnchorEl(value) {
    this.setState({
      anchorEl: value,
      open: !this.state.open,
    });
  }

  handleClose() {
    this.setAnchorEl(null);
  }


  componentDidMount() {
  ///// retrive CategoryList


    fetch(
      `${base.base_url}/website/category/getCategoryList`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          categoryList: result.data,
        });
      });
  


      fetch(
      `${base.base_url}/website/vendor/getVendorListByLocality`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          vendorListByLocality: result.data,
        });
      });
  


//// recomendedVendorList
   fetch(
      `${base.base_url}/website/vendor/recomendedvendorList`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          recomendedVendorList: result.data,
        });
      });

  }







  toggleDrawer = (newOpen) => () => {
    this.setState({
      open: true
    })
  };

  toggleDrawerr = (newOpen) => () => {
    this.setState({
      open: false
    })
  };

  render() {
     let ads_vendor = this.state.recomendedVendorList.filter(e=>e.is_vender_taken_advertisement_packaage==true)
    return (
      <div>
        <Box>

          {
            ///// desktop view here and solution
          }

          <Box>
           <VoiceToText categoryList = {this.state.categoryList}/>
          </Box>



          <Box sx={{ display: { xs: "none", sm: "none", md: "block" },mt:0.3 }}>

            <Box sx={{ minHeight: 750, background: "#ffffff" }}>
              <Container maxWidth="xl">
                <br />
                <br />
          
                
                <Box>
                  <Grid container spacing={1}>
                    <Grid item size={{ xs: 12, sm: 12, md: 9 }}>
                      <br />
               


                      <Box 
                      
                      >
                        <Typography
                          variant="h2"
                          sx={{
                            fontSize: 22,
                            fontWeight: "550",
                            color: "#0a1d3e",
                          }}
                        >
                          Vendors category you may like
                        </Typography>
                        <Typography
                          variant="h2"
                          sx={{
                            fontSize: 12,
                            fontWeight: "500",
                            color: "#0a1d3e",
                          }}
                        >
                          Category you may like or your prefrences.
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            overflowX: "scroll",
                            overflowY: "hidden",
                            mt: 2,
                            mb: 1,
                            whiteSpace: "nowrap",
                            scrollbarWidth: "none",
                          }}
                        >
                          {this.state.categoryList.map((i) => (
                            <Box onClick={()=>this.props.navigate('/venderList',{state : {category_name : i.category_name , address:""}})} sx={{ height: 120, width: 260, mr: 1, mb: 1 }}>
                              
                              <Card
                                elevation={1}
                                sx={{
                                  height: 120,
                                  width: 260,
                                  borderRadius: 2,
                                  mr: 1,
                                  border: 1,
                                  borderColor: "#e9edee",
                                }}
                              >
                                <Box
                                  sx={{
                                    height: 70,
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    pl: 2,
                                    pr: 2,
                                  }}
                                >
                                  <Box sx={{ display: "flex" }}>
                                    <Avatar
                                      alt="Remy Sharp"
                                      src={base.base_url+'/'+ i.category_img}
                                      sx={{ width: 47, height: 47 }}
                                    />
                                  </Box>

                                  <Box sx={{ ml: 1 }}>
                                    <Typography
                                      sx={{
                                        fontWeight: "500",
                                        fontSize: 15,
                                        color: "#233144",
                                      }}
                                    >
                                      {i.category_name}
                                    </Typography>
                                   
                                  </Box>
                                </Box>
                                <Divider />

                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                  onClick={()=>this.props.navigate('/venderList',{state : {category_name : i.category_name , address:""}})}
                                    sx={{
                                      width: "50%",
                                      height: 50,
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: 13,
                                        fontWeight: "600",
                                        color: "#1d75d2",
                                      }}
                                    >
                                      Insight
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      height: 35,
                                      width: 2,
                                      backgroundColor: "#e9edee",
                                    }}
                                  ></Box>
                                  <Box
                                  onClick={()=>this.props.navigate('/venderList',{state : {category_name : i.category_name, address:""}})}
                                    sx={{
                                      width: "50%",
                                      height: 50,
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: 13,
                                        fontWeight: "600",
                                        color: "#1d75d2",
                                      }}
                                    >
                                      Services
                                    </Typography>
                                  </Box>
                                </Box>
                              </Card>

                            </Box>
                          ))}
                        </Box>
                      </Box>

                      <br />



                      <Box>
                        <Typography
                          variant="h2"
                          sx={{
                            fontSize: 23,
                            fontWeight: "550",
                            color: "#0a1d3e",
                          }}
                        >
                        Others Vendors and more
                        </Typography>
                        <Typography
                          variant="h2"
                          sx={{
                            fontSize: 12,
                            fontWeight: "500",
                            color: "#0a1d3e",
                          }}
                        >
                          in south pune
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            overflowX: "scroll",
                            mt: 2,
                            mb: 2,
                            scrollbarWidth: "none",
                          }}
                        >
                          {[
                            { color: "#fef5e4", img: car ,first_name : "Travels &", last_name : "Others"},
                            { color: "#d7f2e3", img: manufacturer ,first_name : "Repairs &", last_name : "Services"},
                            { color: "#fef5e4", img:penter ,first_name : "House Wall", last_name : "Penters"},
                            { color: "#f0f9ff", img: consultant_agency ,first_name :"Consultant", last_name : "Agency" },

                          ].map((i) => (
                            <Box  onClick={()=>this.props.navigate('/venderList',{state : {category_name : "" , address:""}})} sx={{ height: 330, width: 250, mr: 1 }}>
                              <Card
                                elevation={1}
                                sx={{
                                  height: 330,
                                  width: 250,
                                  borderRadius: 2,
                                  backgroundColor: i.color,
                                  backgroundImage: `url(${i.img})`,
                                  backgroundPosition: "center",
                                  backgroundSize: "cover",
                                  backgroundRepeat: "no-repeat",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 24,
                                    fontWeight: "800",
                                    textAlign: "center",
                                    mt: 5,
                                    color: "#445368",
                                  }}
                                >
                                  {i.first_name}
                                  <br />
                                  {i.last_name}
                                </Typography>
                              </Card>
                            </Box>
                          ))}
                        </Box>
                      </Box>

                      <br />

                      <Box sx={{ backgroundColor: "#fbfefe" }}>
                        <Typography
                          variant="h2"
                          sx={{
                            fontSize: 20,
                            fontWeight: "550",
                            color: "#0a1d3e",
                            ml: 2,
                            pt: 2,
                          }}
                        >
                         Services in your locality
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            overflowX:'scroll',
                            scrollbarWidth: "none",
                            p: 2,
                          }}
                        >
                          {this.state.vendorListByLocality.map((row, i) => (
                            <Box key={i._id}  onClick={() =>window.open(`/venderDesc/:${row.vendor_id}`)} sx={{ height: 350,width: 270,mr:1}}>
                            <Paper
                              elevation={0}
                              sx={{
                                height: 350,
                                width: 270,
                                backgroundColor:'#071435',
                                borderRadius: 2,
                                mr: 1,
                              }}
                            >
                              <Box sx={{height:180,width:'100%'}}>
                                 <img style={{height:180,width:270,objectFit:'cover',borderTop:4}} src={base.base_url+'/'+ row.vendors_thumb_nails_img}/>
                              </Box>
                                <Typography sx={{fontSize:18,mt:1,ml:1,fontWeight:'500',color:'#fff'}}>{row.business_name}</Typography>
                                <Typography sx={{fontSize:12,mt:1,ml:1,fontWeight:'400',color:'#fff'}}>{row.vender_personal_address}</Typography>

                                <Box sx={{mt:1}}>
                                  <Button size="small" sx={{fontSize:11,ml:1,backgroundColor:'#ab266c'}} startIcon={<CallIcon sx={{height:11,width:11}}/>} variant="contained">Contact</Button>
                                </Box>

                            </Paper>
                            </Box>
                          ))}
                        </Box>
                        <br />
                      </Box>

                     <br/>

                   <Typography sx={{fontSize:22,fontWeight:'bold',ml:1}}>Favourate Vendors</Typography>
                   <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            maxWidth:'100%',
                            overflowX: "scroll",
                            mt:0.5,
                            mb: 2,
                            scrollbarWidth: "none",
                          }}
                        >
          {
            this.state.recomendedVendorList.map((row,e)=>(
              
        <Box sx={{minHeight:250,m:1,width:260}}  onClick={()=>window.open(`/venderDesc/:${row.vendor_id}`)}>
     <Paper elevation={1} sx={{minHeight:310,width:260 }}>
 

     <img src={base.base_url + '/' + row.vendors_thumb_nails_img} style={{height:150,width:'100%',objectFit:'cover',borderTopLeftRadius:3,borderTopRightRadius:3}}/>


     <Typography sx={{fontSize:15,fontWeight:'600',color:'#0f1f42',textAlign:'left',mt:1,ml:1}}>
      {row.business_name} 
     </Typography>

     <Typography  sx={{mt:0.8,color:'grey',fontWeight:'500',fontSize:12,textAlign:'left',ml:1}}>
      {row.vender_personal_address}
     </Typography>
  
     <Link  sx={{fontSize:15,fontWeight:'600',color:'#0f1f42',textAlign:'left',mt:2,ml:1}}>
      Get Quato
     </Link>

     <Button variant="contained" disableElevation size="small" startIcon={<CallIcon/>} sx={{ml:1,mt:2,mb:1,fontSize:11}}  onClick={()=>window.open(`/venderDesc/:${row.vendor_id}`)}>View Number</Button>
   </Paper>
         </Box>
            ))
          }
         
                  



                   </Box>

                   <br/>


                        <Typography sx={{fontSize:22,fontWeight:'bold',ml:1}}>Vender List</Typography>
                         <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            maxWidth:'100%',
                            overflowX: "scroll",
                            mt:0.5,
                            mb: 2,
                            scrollbarWidth: "none",
                          }}
                        >
          {
            this.state.recomendedVendorList.map((row,i)=>(

         <Box sx={{minHeight:250,m:1,width:260}}  onClick={()=>window.open(`/venderDesc/:${row.vendor_id}`)}>
     <Paper elevation={1} sx={{minHeight:310,width:260 }}>


       <img src={base.base_url + '/' + row.vendors_thumb_nails_img} style={{height:150,width:'100%',objectFit:'cover',borderTopLeftRadius:3,borderTopRightRadius:3}}/>

 
     <Typography  sx={{fontSize:15,fontWeight:'600',color:'#0f1f42',textAlign:'left',mt:1,ml:1}}>
       {row.business_name}
     </Typography>
     <Typography  sx={{mt:0.8,color:'grey',fontWeight:'500',fontSize:12,textAlign:'left',ml:1}}>
       {row.vender_personal_address}
     </Typography>
     <br/>
     <Button variant="contained" disableElevation size="small" startIcon={<CallIcon/>} sx={{ml:1,mt:1,mb:1,fontSize:11,backgroundColor:'#ab266c'}} onClick={()=>window.open(`/venderDesc/:${row.vendor_id}`)}>View Number</Button>
   </Paper>
         </Box>
            ))
          }
         
                  



                   </Box>












                  
                      <br />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 12, md: 3 }}>
                      <Paper sx={{ minHeight: 300, width: "100%", mt: 6, position:'sticky', }}>
                        <br />
                        <Grid container spacing={2}>


                          <Grid item size={{ xs: 6 }}>
                            <Box
                              sx={{
                                backgroundColor: "#fff0e6",
                                height: 120,
                                marginLeft: 1,
                                borderRadius: 3,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  padding: 2,
                                }}
                              >
                                <Typography
                                  sx={{ fontSize: 30, fontWeight: 15 }}
                                >
                                  3
                                </Typography>
                                <ArrowOutwardIcon
                                  fontSize="small"
                                  sx={{ color: "#fe9f43" }}
                                />
                              </Box>

                              <Typography
                                sx={{
                                  paddingLeft: 2,
                                  fontSize: 13,
                                  color: "#42526e",
                                  fontWeight: "700",
                                }}
                              >
                                Shortlisted
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item size={{ xs: 6 }}>
                            <Box
                              sx={{
                                backgroundColor: "#f0f9ff",
                                height: 120,
                                mr: 1,
                                borderRadius: 3,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  padding: 2,
                                }}
                              >
                                <Typography
                                  sx={{ fontSize: 30, fontWeight: 15 }}
                                >
                                  7
                                </Typography>
                                <ArrowOutwardIcon
                                  fontSize="small"
                                  sx={{ color: "#1b7bce" }}
                                />
                              </Box>

                              <Typography
                                sx={{
                                  paddingLeft: 2,
                                  fontSize: 13,
                                  color: "#42526e",
                                  fontWeight: "700",
                                }}
                              >
                                Viewed
                              </Typography>
                            </Box>
                          </Grid>




                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                </Box>
              </Container>
            </Box>
          </Box>
          {
            ///// mobile view and list display here and founded ??
          }
         <br/>
          <Box sx={{ display: { xs: "block", sm: "block",md:'none' }}}>
            <Container maxWidth="xl">
   
            


              <Box sx={{ minHeight: 200, mt: 2 }}>
                <Typography sx={{ fontSize: 19, fontWeight: "600" ,fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                  Recommend Vendors
                </Typography>

                <Grid container spacing={1}>


{
  this.state.vendorListByLocality.map((row,i)=>(
           <Grid item size={{ xs: 6 }}>
                    <Paper  onClick={() =>window.open(`/venderDesc/:${row.vendor_id}`)} elevation={0} sx={{ width: "100%", height: 220 }}>
                      <Box
                        sx={{
                          height: 150,
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          backgroundImage: `url(${base.base_url+'/'+ row.vendors_thumb_nails_img})`,
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          borderRadius: 1,
                        }}
                      >
                        <Box
                          sx={{
                            height: 50,
                            width: "100%",
                            display: "flex",
                            justifyContent: "right",
                            alignItems: "center",
                          }}
                        >
                          <FavoriteBorderIcon
                            sx={{
                              height: 30,
                              width: 30,
                              color: "#fff",
                              backgroundColor: "rgba(2, 7, 13,0.3)",
                              mr: 1,
                            }}
                          />
                        </Box>
                      </Box>
                      <Box>
                        <Typography
                          sx={{ fontSize: 12, color: "black", mt: 0.5,textTransform:'uppercase' ,lineClamp:2 }}
                        >
                          {row.business_name}
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: "gray",m:0.5,lineClamp:2}}>
                          {row.vender_personal_address}
                        </Typography>
                      </Box>
                    </Paper>
           </Grid>
  ))
}
                 



                </Grid>
              </Box>

              <br />
              

              <Box sx={{ maxWidth: "100%" }}>
                <Typography
                  variant="h2"
                  sx={{ fontSize: 18, fontWeight: "550",fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                Others Vendors and more
                </Typography>
            

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    mt: 2,
                    mb: 2,
                    overflowX: "auto",
                    minHeight: 200,
                    whiteSpace: "nowrap",
                    scrollbarWidth: "none",
                  }}
                >
                  {[
                    { color: "#fef5e4", img: car ,first_name : "Travels &", last_name : "Others"},
                            { color: "#f0f9ff", img: d ,first_name : "Residencial", last_name : "Land"},
                            { color: "#d7f2e3", img: manufacturer ,first_name : "Repairs &", last_name : "Services"},
                            { color: "#fef5e4", img:penter ,first_name : "House Wall", last_name : "Penters"},
                            { color: "#f0f9ff", img: car ,first_name :"Commercial", last_name : "Apartment" },
                  ].map((i) => (
                    <Box  onClick={()=>window.open('/venderList')} sx={{ height: 250, width: 220, mr: 1 }}>
                      <Box
                        elevation={0}
                        sx={{
                          height: 250,
                          width: 220,
                          borderRadius: 2,
                          backgroundColor: i.color,
                          backgroundImage: `url(${i.img})`,
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 21,
                            fontWeight: "800",
                            textAlign: "center",
                            pt: 3,
                            color: "#445368",
                          }}
                        >
                          {i.first_name}
                          <br />
                          {i.last_name}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>


              <br />


              <Box sx={{ maxWidth: "100%" }}>
                <Typography
                  variant="h2"
                  sx={{ fontSize: 18, fontWeight: "550",fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                 Vendor Popular category
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    mt: 2,
                    mb: 2,
                    overflowX: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                   {this.state.categoryList.map((i) => (
                    <Box  onClick={()=>this.props.navigate('/venderList',{state : {category_name : i.category_name , address:""}})} 
                      sx={{
                        height: 120,
                        width: 240,
                        borderRadius: 2,
                        mb: 1,
                        mr: 1,
                      }}
                    >
                      <Card
                        elevation={1}
                        sx={{
                          height: 120,
                          width: 240,
                          borderRadius: 2,
                          border: 1,
                          borderColor: "#e9edee",
                        }}
                      >
                        <Box
                          sx={{
                            height: 70,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            pl: 2,
                            pr: 2,
                          }}
                        >
                          <Box sx={{ display: "flex" }}>
                            <Avatar
                              alt="Remy Sharp"
                              src={base.base_url + '/' + i.category_img}
                              sx={{ width: 47, height: 47 }}
                            />
                          </Box>

                          <Box sx={{ ml: 1 }}>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: 13,
                                color: "#233144",
                              }}
                            >
                              {i.category_name}
                            </Typography>
                          </Box>
                        </Box>
                        <Divider />

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              width: "50%",
                              height: 50,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: 13,
                                fontWeight: "600",
                                color: "#1d75d2",
                              }}
                            >
                              Insight
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              height: 35,
                              width: 2,
                              backgroundColor: "#e9edee",
                            }}
                          ></Box>
                          <Box
                            sx={{
                              width: "50%",
                              height: 50,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: 13,
                                fontWeight: "600",
                                color: "#1d75d2",
                              }}
                            >
                              Services
                            </Typography>
                          </Box>
                        </Box>
                      </Card>
                    </Box>
                  ))}
                </Box>
              </Box>


              <br />


              <Box sx={{ maxWidth: "100%" }}>
                <Typography
                  variant="h2"
                  sx={{ fontSize: 18, fontWeight: "550",fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                 VendorList By Locality
                </Typography>
            
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    mt: 2,
                    mb: 2,
                    overflowX: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                  {this.state.vendorListByLocality.map((i) => (
                    <Box   onClick={() =>window.open(`/venderDesc/:${i.vendor_id}`)} sx={{ height: 250, width: 250, mr: 1 }}>
                      <Paper elevation={0} sx={{ height: 250, width: 250 }}>
                        <Box
                          sx={{
                            height: 150,
                            width: "100%",
                            borderRadius: 2,
                            backgroundImage: `url(${base.base_url + '/'+i.vendors_thumb_nails_img})`,
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                          }}
                        >
                          <Box
                            sx={{
                              height: 50,
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                height: 15,
                                width: 60,
                                backgroundColor: "#04afaf",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CheckIcon
                                sx={{ height: 13, width: 13, color: "#fff" }}
                              />{" "}
                              <Typography
                                sx={{
                                  color: "#fff",
                                  fontSize: 9,
                                  ml: 0.5,
                                  mt: 0.5,
                                  fontWeight: "600",
                                }}
                              >
                                Verified
                              </Typography>
                            </Box>
                            <FavoriteBorderIcon
                              sx={{
                                height: 25,
                                width: 25,
                                color: "#fff",
                                mr: 1,
                              }}
                            />
                          </Box>
                        </Box>

                        <Typography
                          sx={{
                            fontSize: 15,
                            fontWeight: "600",
                            color: "#0f1f42",
                            textAlign: "left",
                            mt: 1,
                          }}
                        >{
                          i.business_name
                        } 
                        </Typography>
                        <Typography
                          sx={{
                            mt: 0.8,
                            color: "grey",
                            fontWeight: "500",
                            fontSize: 12,
                            textAlign: "left",
                          }}
                        >
                       {i.vender_personal_address}
                        </Typography>
                      </Paper>
                    </Box>
                  ))}
                </Box>
              </Box>




              <Box sx={{ maxWidth: "100%" }}>
                <Typography
                  variant="h2"
                  sx={{ fontSize: 18, fontWeight: "550",fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                 Services , Vendor and More
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    mt: 2,
                    mb: 2,
                    overflowX: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                  {this.state.recomendedVendorList.map((i) => (
                    <Box   onClick={() =>window.open(`/venderDesc/:${i.vendor_id}`)} sx={{ height: 150, width: 270, mr: 1 }}>
                      <Paper elevation={1} sx={{ height: 150, width: 270 }}>
                      <Box sx={{height:150,width:'100%',borderRadius:2,backgroundImage: `url(${base.base_url+'/'+i.vendors_thumb_nails_img})`,backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>
     
                      <Box sx={{height:50,width:'100%',display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                       <Box sx={{height:15,width:60,backgroundColor:'#04afaf',display:'flex',justifyContent:'center',alignItems:'center'}}>
                         <CheckIcon sx={{height:13,width:13,color:'#fff'}}/> <Typography  sx={{color:'#fff',fontSize:9,ml:0.5,mt:0.5,fontWeight:'600'}}>Verified</Typography>
                       </Box>
                      <FavoriteBorderIcon sx={{height:25,width:25,color:'#fff',mr:1}}/>
                        </Box>
  
                        </Box>
                      </Paper>
                    </Box>
                  ))}
                </Box>
              </Box>
              



                 <Typography sx={{ fontSize: 18, fontWeight: "550",fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,mb:1}}>
                    Others Vendors and more</Typography>
                  <Box
                            sx={{
                              display: "flex",
                              maxWidth:'100%',
                              flexDirection: "row",
                              mt: 1,
                              mb: 2, 
                              overflowX: "scroll",
                              scrollbarWidth: "none",
                            }}
                        >
          {
            this.state.recomendedVendorList.map((e)=>(
      <Box   onClick={() =>window.open(`/venderDesc/:${e.vendor_id}`)} sx={{minHeight:200,m:1,width:260}}>
     <Paper elevation={1} sx={{minHeight:270,width:260 }}>
     <Box sx={{height:150,width:'100%',borderRadius:2,backgroundImage: `url(${base.base_url + '/'+ e.vendors_thumb_nails_img})`,backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>
     
     <Box sx={{height:50,width:'100%',display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
           <Box sx={{height:15,width:90,backgroundColor:'#04afaf',display:'flex',justifyContent:'center',alignItems:'center'}}>
              <CheckIcon sx={{height:13,width:13,color:'#fff'}}/> <Typography  sx={{color:'#fff',fontSize:9,ml:0.5,mt:0.5,fontWeight:'600'}}>RECOMENDED</Typography>
      </Box>
            <FavoriteBorderIcon sx={{height:25,width:25,color:'#fff',mr:1}}/>
     </Box>
  
     </Box>
 
     <Typography  sx={{fontSize:15,fontWeight:'600',color:'#0f1f42',textAlign:'left',mt:1,ml:1}}>
       {e.business_name}
     </Typography>
     <Typography  sx={{mt:0.8,color:'grey',fontWeight:'500',fontSize:12,textAlign:'left',ml:1}}>
      {e.vender_personal_address}
     </Typography>

     <Button variant="contained" disableElevation size="small" startIcon={<CallIcon/>} sx={{ml:1,mt:1,mb:2,fontSize:11}}>View Number</Button>
   </Paper>
         </Box>
            ))
          }
         

                  </Box>


          



            </Container>
          </Box>
        </Box>


        




           <Dialog   open={this.state.is_ads_open}>

         

             <Box sx={{height:300,width:350,backgroundColor:'#fff'}}>
                
        <Carousel> 
          {ads_vendor.map((r)=>(       
          <Carousel.Item>

             <img src={base.base_url+'/'+ r.vendors_thumb_nails_img} style={{height:300,width:350, objectFit:'fill'}}/>
             <Carousel.Caption>
          <h3 style={{fontSize:16,fontWeight:'bold',color:'#008ffb'}}>{r.business_name}</h3>
          <p style={{color:'green',fontSize:10,fontweight:'bold',backgroundColor:'#e26511',WebkitLineClamp: 1, display: '-webkit-box',}}>{r.bussiness_desc}</p>
          <Button onClick={()=>window.open(`tel:${r.vendor_personal_contact_number}`)} variant="contained" startIcon={<CallIcon/>} size="small">Call now</Button>

          <Button variant="contained" onClick={()=>this.setState({is_ads_open:false})}  startIcon={<CloseIcon/>} sx={{ml:2,backgroundColor:'red'}} size="small">Close</Button>
        </Carousel.Caption>
          </Carousel.Item>
             )) }        
      </Carousel>

              </Box>
            
            </Dialog>     



         






      </div>
    );
  }
}

export default Main;




export function Mainc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<Main param={param} location={location} navigate={navigate}></Main>)}
